// On phones the home page events list stays hidden (see base.css) until it has
// events to show, so shoppers never land on its "No results" state. When the
// current month has no upcoming event, the list opens on the month of the next one.
(() => {
  const containers = document.querySelectorAll('.Evey__EventListContainer');
  if (!containers.length || !window.Shopify?.shop) return;

  const formatDate = date =>
    [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');

  const whenLoaded = loader =>
    new Promise(resolve => {
      if (!loader || loader.style.display === 'none') return resolve();
      new MutationObserver((_, observer) => {
        if (loader.style.display !== 'none') return;
        observer.disconnect();
        resolve();
      }).observe(loader, { attributes: true, attributeFilter: ['style'] });
    });

  const revealOnceListed = container => {
    const list = container.querySelector('.Evey__EventList');
    if (!list) return;

    const reveal = () => {
      if (!list.children.length) return false;
      container.closest('.shopify-section')?.classList.add('has-upcoming-events');
      return true;
    };

    if (reveal()) return;
    new MutationObserver((_, observer) => reveal() && observer.disconnect()).observe(list, { childList: true });
  };

  // Evey's calendar returns one month at a time, keyed by a first-of-month startDate.
  const now = new Date();
  const hasUpcomingEvent = month => {
    const url = new URL('https://api.eveyevents.com/production-v2/storefront/calendar');
    url.search = new URLSearchParams({ shop: Shopify.shop, startDate: month, search: '', strict: true });
    return fetch(url)
      .then(response => response.json())
      .then(({ schedule }) => (schedule || []).some(item => new Date(item.start) >= now));
  };

  const findNextEventMonth = async () => {
    for (let offset = 0; offset < 12; offset++) {
      const month = formatDate(new Date(now.getFullYear(), now.getMonth() + offset, 1));
      if (await hasUpcomingEvent(month)) return month;
    }
    return null;
  };

  containers.forEach(revealOnceListed);

  // Larger screens keep the filters and open on the current month
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  findNextEventMonth()
    .then(nextMonth => {
      if (!nextMonth) return;

      containers.forEach(container => {
        const monthSelect = container.querySelector('.Evey__EventsFilter__Month select');
        if (!monthSelect || monthSelect.value === nextMonth) return;

        whenLoaded(container.querySelector('.Evey__EventList__Loading')).then(() => {
          monthSelect.value = nextMonth;
          monthSelect.dispatchEvent(new Event('change'));
        });
      });
    })
    .catch(() => {});
})();
